module.exports = __webpack_public_path__ + "img/ic-clear.2a5e36fc.svg";